import {useState} from 'react';

import {articleMemoryRepository} from '../../repositories/article-memory-repository';

export const useArticleFromMemory = articleId => {
  const [
    articlesFromMemory,
    setArticlesFromMemory
  ] = useState(articleMemoryRepository.get());

  articleMemoryRepository.subscribe((_, value) => setArticlesFromMemory(value));

  return articlesFromMemory[articleId];
};
